export default function Bookmarks() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-semibold mb-4">Bookmarks</h1>
      <p className="text-gray-500">Shared bookmarks coming soon...</p>
    </div>
  );
}
